import {REQUEST_ASP_LOCATIONS, requestAspLocations, RECEIVE_DATA, receiveData, RECEIVE_COUNTRIES} from "../actions"

const initialState = {
    loaded: false,
    pending: false,
    locations: [],
    Countries: [],
    error: null
}

//Reducers
export default function aspLocationsReducer(state = initialState, action) {
    switch (action.type) {
        case REQUEST_ASP_LOCATIONS:
            console.log("Req ASP locations fired")
            return { ...state, pending: true }
        case RECEIVE_DATA:
            return {
                ...state,
                locations: action.payload,
                pending: false,
                loaded: true
            }
        case RECEIVE_COUNTRIES:
            return {
                ...state,
                countries: action.payload,
            }
        default:
            return state
    }
}